import * as React from 'react';
import clsx from 'clsx';
import { InputProps } from '@/interfaces';
import { Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';
import { XIcon } from 'lucide-react';
import { Input } from '../input/input';

interface InputRadioBgIconI {
	bgIcon?: 'check' | 'x';
	classNameButton?: string;
}

export const InputRadioBgIcon: React.FC<
	InputProps & React.InputHTMLAttributes<HTMLInputElement> & InputRadioBgIconI
> = ({
	name,
	register,
	children,
	className,
	value,
	disabled,
	onChangeCustom,
	bgIcon,
	classNameButton,
	...props
}) => {
	return (
		<div className={clsx(className)}>
			<button
				type="button"
				className={clsx(
					'w-6 h-6 border border-opacity-primary',
					'rounded relative bg-gradient-to-b from-white to-gray-100',
					classNameButton
				)}
				onClick={() => {
					onChangeCustom && onChangeCustom(value as any);
				}}
				disabled={disabled}
			>
				{bgIcon && bgIcon === 'check' ? (
					<Icon
						src={Icons.checkGreen}
						className="absolute top-[1px] right-[1px]"
						width={20}
						height={20}
					/>
				) : bgIcon && bgIcon === 'x' ? (
					<XIcon
						className="absolute top-0.5 right-[1px] text-grey-30"
						width={20}
						height={20}
					/>
				) : null}
				<Typography type="regular-16" className="ml-12">
					{children}
				</Typography>
			</button>
			<Input name={name} register={register} hidden {...props} />
		</div>
	);
};
